const PB_BASE = 'https://pb.cameraplugin.com/api/collections/profiles/records';

export async function getProfiles() {
  const response = await fetch(PB_BASE + '?perPage=500');
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Failed to fetch profiles');
  return (body.items || []).map((item) => ({
    id: item.id,
    email: item.email || '',
    app_password: item.app_password || '',
    cnn: item.cnn || '',
    date_reserver: item.date_reserver || '',
    date_taken: item.date_taken || '',
    id_pc: item.id_pc || '',
    phone_number: item.phone_number || '',
    created: item.created || '',
    updated: item.updated || '',
  }));
}

export async function createProfile(data) {
  const response = await fetch(PB_BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Failed to create profile');
  return body;
}

export async function updateProfile(id, data) {
  const response = await fetch(`${PB_BASE}/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Failed to update profile');
  return body;
}

export async function deleteProfile(id) {
  const response = await fetch(`${PB_BASE}/${id}`, { method: 'DELETE' });
  if (!response.ok) {
    const body = await response.json();
    throw new Error(body.message || 'Failed to delete profile');
  }
}
